import { render } from "./CRMIntegrationView.vue?vue&type=template&id=cf162dd2&scoped=true"
import script from "./CRMIntegrationView.vue?vue&type=script&lang=js"
export * from "./CRMIntegrationView.vue?vue&type=script&lang=js"

import "./CRMIntegrationView.vue?vue&type=style&index=0&id=cf162dd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf162dd2"]])

export default __exports__